import { render } from "./DecorationSetsListPage.vue?vue&type=template&id=3d8d2d29&scoped=true"
import script from "./DecorationSetsListPage.vue?vue&type=script&lang=js"
export * from "./DecorationSetsListPage.vue?vue&type=script&lang=js"

import "./DecorationSetsListPage.vue?vue&type=style&index=0&id=3d8d2d29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8d2d29"]])

export default __exports__